/**
 * Shared styled components for auth feature (login, register, forgot password, reset).
 * Uses theme tokens from @/libs/theme (via ThemeProvider). No inline styles, no hardcoded colors.
 */
import { Form } from 'antd'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const AuthForm = styled(Form)`
  width: 100%;
`

export const AuthLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  &:hover {
    color: ${({ theme }) => theme.colors.primaryHover};
  }
`

export const AuthFooterText = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing.lg};

  a {
    color: ${({ theme }) => theme.colors.primary};
    &:hover {
      color: ${({ theme }) => theme.colors.primaryHover};
    }
  }
`

export const AuthTitleWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`

export const AuthLabelAsterisk = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const AuthFormItemSubmit = styled(Form.Item)`
  margin-top: ${({ theme }) => theme.spacing.lg};
`

export const AuthSubtitleText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  display: block;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const AuthFormItemRow = styled(Form.Item)`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`

export const AuthRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
`

export const AuthRowItem = styled(Form.Item)`
  flex: 1;
  margin-bottom: 0;
`
